import { useEffect, useState } from 'react';

import Communicator from '../helpers/communication-adapter';
import { CommunicationMessageTypes } from '../helpers/constants';
import { waitForMonitors } from '../helpers/utils';
import { IMonitorInitSync } from '../types/communicator-types';
import useCommunicator from './useCommunicator';

export default function useSystemReadyWithMonitors(numOfMonitors: number) {
  const [isSystemReady, setIsSystemReady] = useState(false);
  const communicator = useCommunicator<IMonitorInitSync>(
    CommunicationMessageTypes.MonitorInitConfig
  );
  useEffect(() => {
    if (Communicator.isReady && communicator) {
      (async () => {
        await waitForMonitors(numOfMonitors, communicator);
        setIsSystemReady(true);
      })();
    }
  }, [communicator]);
  return {
    systemReady: isSystemReady,
    resetSystem: () => setIsSystemReady(false),
  };
}
